import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {MultiSelect} from 'primereact/multiselect';
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import {classNames} from "primereact/utils";
import {Dropdown} from "primereact/dropdown";
import {ColorPicker} from 'primereact/colorpicker';
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {FileUpload} from "primereact/fileupload";
import {Fieldset} from "primereact/fieldset";
import FormLocker from "../../util/FormLocker";
import Cropper from "react-easy-crop";
import getCroppedImg from 'assets/imageCropper'
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";

const _FM_GuestinforequestFormComponent = (props) => {
  const LOGO_ASPECT_RATIO = 200 / 28;

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({
    primary_color: '#e6f8f3',
    secondary_color: '#ffffff',
  });
  const [newFormData, setNewFormData] = useState({});
  const [fields, setFields] = useState([]);
  const [relations, setRelations] = useState([]);
  const [recommendedCollections, setRecommendedCollections] = useState([]);
  const [selectedRecommendedCollectionIds, setSelectedRecommendedCollectionIds] = useState([]);
  const [recommendedCollectionItemsById, setRecommendedCollectionItemsById] = useState({});
  const [collectionInsertedFieldKeysById, setCollectionInsertedFieldKeysById] = useState({});
  const [recommendedCollectionsLoading, setRecommendedCollectionsLoading] = useState(false);
  const [newField, setNewField] = useState({});
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const [crop, setCrop] = useState({x: 0, y: 0});
  const [zoom, setZoom] = useState(1);
  const MIN_CROP_ZOOM = 0.1;
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [selectedImagePreviewUrl, setSelectedImagePreviewUrl] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const hasPersistedImage = Boolean(formData?.image_url?.toString().includes('.'));
  const hasLocalImage = Boolean(selectedImageFile || selectedImagePreviewUrl || formData?.image?.name);
  const hasImageToDelete = hasPersistedImage || hasLocalImage;
  const imageUploadChooseLabel = selectedImageFile ? 'Új file kiválasztása' : t('file_choose');

  const clearSelectedImageState = () => {
    setSelectedImageFile(null);
    if (selectedImagePreviewUrl) {
      URL.revokeObjectURL(selectedImagePreviewUrl);
    }
    setSelectedImagePreviewUrl(null);
    setCrop({x: 0, y: 0});
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  const handleImageSelect = (e) => {
    const file = e.files?.[0];
    if (!file) {
      return;
    }

    const maxFileSize = 1 * 1024 * 1024;
    if (file.size > maxFileSize) {
      window.App.toastShow('warn', t('warning'), t('file_too_large'));
      return;
    }

    if (selectedImagePreviewUrl) {
      URL.revokeObjectURL(selectedImagePreviewUrl);
    }
    setSelectedImageFile(file);
    setSelectedImagePreviewUrl(URL.createObjectURL(file));
    setCrop({x: 0, y: 0});
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  const handleImageSave = async () => {
    let fileToSave = selectedImageFile;

    if (!fileToSave) {
      window.App.toastShow('warn', t('warning'), t('file_choose'));
      return;
    }

    if (selectedImagePreviewUrl && croppedAreaPixels) {
      try {
        const croppedBlobUrl = await getCroppedImg(selectedImagePreviewUrl, croppedAreaPixels);
        const response = await fetch(croppedBlobUrl);
        const blob = await response.blob();
        URL.revokeObjectURL(croppedBlobUrl);
        const fileNameWithoutExtension = selectedImageFile?.name?.replace(/\.[^/.]+$/, '') || 'image';
        fileToSave = new File([blob], fileNameWithoutExtension + "_cropped.png", {type: 'image/png'});
      } catch (error) {
        window.App.toastShow('error', t('error'), error.toString());
        return;
      }
    }

    if (!formData.id) {
      setFormData({
        ...formData,
        image: fileToSave
      });
      clearSelectedImageState();
      return;
    }

    setImageUploading(true);
    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest-information-request-page/image/" + formData.id,
      {
        image: fileToSave
      },
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language"),
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        window.App.toastShow('success', t('success'), response.data.message)
        clearSelectedImageState();
        window.App.setState({
          rerenderGuestinforequestForm: true,
        })
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setImageUploading(false);
      })
  };

  const validate = (data) => {
    let errors = {};
    return errors;
  };

  const sanitizeAdditionalFields = (additionalFields = []) => (
    additionalFields.map((field) => {
      const {
        _class_name,
        _country_specifics,
        created_at_snapshot,
        guest_information_request_page,
        id,
        updated_at_snapshot,
        ...sanitizedField
      } = field || {};

      return sanitizedField;
    })
  );

  const buildAdditionalFieldKey = (field = {}) => (
    [field?.name || '', field?.label || '', String(field?.sort ?? ''), field?.related_to || ''].join('::')
  );

  const normalizeRecommendedCollectionItems = (items = []) => (
    items.map((item, index) => ({
      name: item?.name || '',
      label: item?.label || '',
      sort: item?.sort || index + 1,
      related_to: item?.related_to || null,
    }))
  );

  const fetchRecommendedCollectionItems = (collectionId) => {
    if (recommendedCollectionItemsById[collectionId]) {
      return Promise.resolve(recommendedCollectionItemsById[collectionId]);
    }

    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "girp-additional-field-collection/" + collectionId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        const normalizedItems = normalizeRecommendedCollectionItems(response?.data?.data?.items || []);
        setRecommendedCollectionItemsById((prev) => ({
          ...prev,
          [collectionId]: normalizedItems,
        }));
        return normalizedItems;
      });
  };

  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      const payload = (newField.name && newField.label && newField.sort && newField.related_to) ? {
        ...newFormData,
        girp_additional_fields: sanitizeAdditionalFields([
          ...(formData.girp_additional_fields || []),
          newField
        ]),
      } : {
        ...newFormData
      };

      if (payload.girp_additional_fields) {
        payload.girp_additional_fields = sanitizeAdditionalFields(payload.girp_additional_fields);
      }

      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
        + "guest-information-request-page/" + formData.id,
        payload,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({});
          setNewField({
            name: '',
            label: '',
            sort: '',
            related_to: null
          })
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderGuestinforequestList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest-information-request-page",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderGuestinforequestList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    setSelectedRecommendedCollectionIds([]);
    setCollectionInsertedFieldKeysById({});
    setRecommendedCollectionItemsById({});
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
        + "dictionary/guest-information-request-page-basic-field",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        let _fields = []
        response.data.data.fields.map((field, index) => {
          _fields.push({
            name: field,
            code: field
          })
        })
        setFields(_fields)
      })
      .catch(error => {

      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/girp-additional-field-related-to",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setRelations(response.data.data)
      })
      .catch(error => {

      })
    setRecommendedCollectionsLoading(true)
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "girp-additional-field-collection",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setRecommendedCollections(response?.data?.data.items || [])
      })
      .catch(error => {
        setRecommendedCollections([])
      })
      .finally(() => {
        setRecommendedCollectionsLoading(false)
      })
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest-information-request-page/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from
            && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    window.App.setState({rerenderGuestinforequestForm: false})
  }, [window.App.state.rerenderGuestinforequestForm === true])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message">
        <i className="pi pi-exclamation-triangle blocked-ui-message-icon"
           aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col"}>
                  <h2 className={"p-m-0"}>{t('guestinforequest_form')}</h2>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <HelpComponent type={"section"} tabNumber={1} sectionNumber={1}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="customer_required_fields" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="customer_required_fields"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('customer_required_fields')}</label>
                      <span className="p-d-block">
                        <MultiSelect value={formData.customer_required_fields}
                                     options={fields}
                                     optionLabel={(option) => window.App.getTranslatedLabel(option.name)}
                                     optionValue="code"
                                     onChange={(e) => {
                                       setFormData({...formData, customer_required_fields: e.value})
                                       setNewFormData({
                                         ...newFormData,
                                         customer_required_fields: e.value
                                       })
                                     }}
                        />
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="primary_color" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="primary_color"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('primary_color')}</label>
                      <span className="p-d-block">
                        <ColorPicker value={formData.primary_color || '#ffffff'}
                                     onChange={(e) => {
                                       const color = '#' + e.target.value
                                       setFormData({
                                         ...formData,
                                         primary_color: color
                                       })
                                       setNewFormData({
                                         ...newFormData,
                                         primary_color: color
                                       })
                                     }}
                        />
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="secondary_color" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="secondary_color"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('secondary_color')}</label>
                      <span className="p-d-block">
                        <ColorPicker value={formData.secondary_color || '#ffffff'}
                                     onChange={(e) => {
                                       const color = '#' + e.target.value
                                       setFormData({
                                         ...formData,
                                         secondary_color: color
                                       })
                                       setNewFormData({
                                         ...newFormData,
                                         secondary_color: color
                                       })
                                     }}
                        />
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="image" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"image"}/>
                      <label htmlFor="image"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>Logo</label>
                      {!selectedImageFile &&
                        <>
                          <span className="p-d-block">
                            <FileUpload mode="basic"
                                        chooseLabel={imageUploadChooseLabel}
                                        chooseOptions={{className: 'w-100'}}
                                        className="w-100 custom-image-fileupload"
                                        name="image"
                                        accept="image/*"
                                        onSelect={handleImageSelect}
                            />
                          </span>
                        </>
                      }
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                  <div className="p-field p-fluid">
                    <span className="p-d-block p-text-bold">
                      {formData?.image_url?.toString().includes('.') &&
                        !selectedImagePreviewUrl &&
                        <img
                          src={process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.toString().replace("/api/", "") + formData.image_url}
                          alt=""
                          className={"w-100 p-mt-2"}/>
                      }
                      {formData.image && !selectedImagePreviewUrl &&
                        <>
                          {formData?.image?.name}
                        </>
                      }
                    </span>
                    {selectedImagePreviewUrl &&
                      <>
                        <div className="p-mt-3 p-mb-2">Crop</div>
                        <div className={"p-mt-2"} style={{position: 'relative', width: '100%', height: 320}}>
                          <Cropper
                            image={selectedImagePreviewUrl}
                            crop={crop}
                            zoom={zoom}
                            aspect={LOGO_ASPECT_RATIO}
                            minZoom={MIN_CROP_ZOOM}
                            restrictPosition={false}
                            style={{
                              containerStyle: {backgroundColor: 'transparent'},
                              cropAreaStyle: {
                                boxShadow: '0 0 0 9999em rgba(0,0,0,0)',
                                border: '1px solid #ced4da'
                              }
                            }}
                            onCropChange={setCrop}
                            onCropComplete={(_, areaPixels) => setCroppedAreaPixels(areaPixels)}
                            onZoomChange={setZoom}
                          />
                        </div>
                        <div className={"p-mt-2"}>
                          <input
                            type="range"
                            min={MIN_CROP_ZOOM}
                            max={3}
                            step={0.1}
                            value={zoom}
                            onChange={(e) => setZoom(Number(e.target.value))}
                            style={{width: '100%'}}
                          />
                        </div>
                        <div className={"p-mt-2"}>
                          <FileUpload mode="basic"
                                      chooseLabel={imageUploadChooseLabel}
                                      chooseOptions={{className: 'w-100'}}
                                      className="w-100 custom-image-fileupload"
                                      name="image_replace"
                                      accept="image/*"
                                      onSelect={handleImageSelect}/>
                        </div>
                      </>
                    }
                    {selectedImageFile &&
                      <div className={"p-mt-3"}>
                        <Button type="button"
                                icon={"pi pi-save"}
                                label={t('save')}
                                className="p-button-success"
                                loading={imageUploading}
                                onClick={handleImageSave}/>
                      </div>
                    }
                    {hasImageToDelete &&
                      <div className={"p-mt-3"}>
                        <Button type="button"
                                icon="pi pi-trash"
                                label={t('delete')}
                                className="p-button-danger"
                                onClick={() => {
                                  if (!formData?.id) {
                                    setFormData((prev) => ({
                                      ...prev,
                                      image: null,
                                      image_url: null,
                                    }));
                                    clearSelectedImageState();
                                    return;
                                  }
                                  axios.delete(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest-information-request-page/image/" + formData.id,
                                    {
                                      params: {},
                                      headers: {
                                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                        "Sys-name": Cookies.get("instanceId"),
                                        "Preferred-locale": Cookies.get("language")
                                      }
                                    })
                                    .then((response) => {
                                      window.App.toastShow('success', t('success'), response.data.message)
                                      setFormData((prev) => ({
                                        ...prev,
                                        image: null,
                                        image_url: null,
                                      }));
                                      clearSelectedImageState();
                                      window.App.setState({
                                        rerenderGuestinforequestForm: true,
                                      })
                                    })
                                    .catch(error => {
                                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                    })
                                }}/>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
        <BlockUI blocked={!formData.id} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i
          className="pi pi-exclamation-triangle blocked-ui-message-icon"
          aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0"}>{t('girp_additional_fields')}</h3>
            <HelpComponent type={"section"} tabNumber={1} sectionNumber={2}/>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="recommended_collection">{t('recommendations')}</label>
                  <MultiSelect options={recommendedCollections}
                               id={"recommended_collection"}
                               optionLabel="name"
                               optionValue="id"
                               emptyMessage={t('empty_message')}
                               value={selectedRecommendedCollectionIds}
                               disabled={!formData?.id}
                               loading={recommendedCollectionsLoading}
                               showSelectAll={false}
                               filter={false}
                               onChange={async (e) => {
                                 const nextSelectedIds = e.value || [];
                                 const prevSelectedIds = selectedRecommendedCollectionIds || [];
                                 const addedIds = nextSelectedIds.filter((collectionId) => !prevSelectedIds.includes(collectionId));
                                 const removedIds = prevSelectedIds.filter((collectionId) => !nextSelectedIds.includes(collectionId));

                                 setSelectedRecommendedCollectionIds(nextSelectedIds);

                                 if (removedIds.length > 0) {
                                   const removedFieldKeys = new Set();
                                   removedIds.forEach((collectionId) => {
                                     (collectionInsertedFieldKeysById[collectionId] || []).forEach((fieldKey) => {
                                       removedFieldKeys.add(fieldKey);
                                     });
                                   });

                                   const stillUsedFieldKeys = new Set();
                                   nextSelectedIds.forEach((collectionId) => {
                                     (collectionInsertedFieldKeysById[collectionId] || []).forEach((fieldKey) => {
                                       stillUsedFieldKeys.add(fieldKey);
                                     });
                                   });

                                   if (removedFieldKeys.size > 0) {
                                     setFormData((prev) => {
                                       const nextAdditionalFields = (prev.girp_additional_fields || []).filter((field) => {
                                         const fieldKey = buildAdditionalFieldKey(field);
                                         return !removedFieldKeys.has(fieldKey) || stillUsedFieldKeys.has(fieldKey);
                                       });

                                       setNewFormData((prevNewFormData) => ({
                                         ...prevNewFormData,
                                         girp_additional_fields: nextAdditionalFields,
                                       }));

                                       return {
                                         ...prev,
                                         girp_additional_fields: nextAdditionalFields,
                                       };
                                     });
                                   }

                                   setCollectionInsertedFieldKeysById((prev) => {
                                     const next = {...prev};
                                     removedIds.forEach((collectionId) => {
                                       delete next[collectionId];
                                     });
                                     return next;
                                   });
                                 }

                                 if (addedIds.length === 0 || !formData?.id) {
                                   return;
                                 }

                                 setRecommendedCollectionsLoading(true);
                                 try {
                                   const addedItemsById = {};
                                   for (const collectionId of addedIds) {
                                     addedItemsById[collectionId] = await fetchRecommendedCollectionItems(collectionId);
                                   }

                                   setFormData((prev) => {
                                     const nextAdditionalFields = [...(prev.girp_additional_fields || [])];
                                     const existingFieldKeys = new Set(nextAdditionalFields.map((field) => buildAdditionalFieldKey(field)));
                                     const nextInsertedFieldKeysById = {};

                                     addedIds.forEach((collectionId) => {
                                       const insertedFieldKeys = [];
                                       (addedItemsById[collectionId] || []).forEach((field) => {
                                         const fieldKey = buildAdditionalFieldKey(field);
                                         if (!existingFieldKeys.has(fieldKey)) {
                                           existingFieldKeys.add(fieldKey);
                                           insertedFieldKeys.push(fieldKey);
                                           nextAdditionalFields.push(field);
                                         }
                                       });
                                       nextInsertedFieldKeysById[collectionId] = insertedFieldKeys;
                                     });

                                     setCollectionInsertedFieldKeysById((prevInsertedFieldKeysById) => ({
                                       ...prevInsertedFieldKeysById,
                                       ...nextInsertedFieldKeysById,
                                     }));

                                     setNewFormData((prevNewFormData) => ({
                                       ...prevNewFormData,
                                       girp_additional_fields: nextAdditionalFields,
                                     }));

                                     return {
                                       ...prev,
                                       girp_additional_fields: nextAdditionalFields,
                                     };
                                   });
                                 } catch (error) {
                                   window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response);
                                 } finally {
                                   setRecommendedCollectionsLoading(false);
                                 }
                               }}
                  />
                </div>
              </div>
            </div>
            <table className={"w-100 p-datatable-table table-striped item-add-table"} cellPadding={0} cellSpacing={0}
                   border={0}>
              <tr>
                <th>
                  {t('id')}
                </th>
                <th>
                  {t('label')}
                </th>
                <th>
                  {t('sort')}
                </th>
                <th>
                  {t('related_to')}
                </th>
                <th>

                </th>
              </tr>
              {formData.girp_additional_fields && formData.girp_additional_fields[0] &&
                <>
                  {formData.girp_additional_fields.map((field, index) => {
                    return (
                      <tr>
                        <td>
                          {field.name}
                        </td>
                        <td>
                          {field.label}
                        </td>
                        <td>
                          {field.sort}
                        </td>
                        <td>
                          {t(field?.related_to?.toLowerCase())}
                        </td>
                        <td className={"p-text-right"}>
                          <Button icon="pi pi-trash" className="p-button-sm p-button-danger p-p-1"
                                  tooltip={t('delete')}
                                  tooltipOptions={{position: 'left'}}
                                  onClick={() => {
                                    let _fields = formData.girp_additional_fields
                                    _fields.splice(index, 1)
                                    axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
                                      + "guest-information-request-page/" + formData.id,
                                      {
                                        girp_additional_fields: sanitizeAdditionalFields(_fields),
                                      }, {
                                        params: {},
                                        headers: {
                                          'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                          "Sys-name": Cookies.get("instanceId"),
                                          "Preferred-locale": Cookies.get("language")
                                        }
                                      })
                                      .then(response => {
                                        setFormData(response.data.data);
                                        setLoading(false)
                                        window.App.toastShow('success', t('success'), response.data.message)
                                      })
                                      .catch(error => {
                                        setLoading(false)
                                        window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                      })

                                  }}
                          />
                        </td>
                      </tr>
                    )
                  })}
                </>
              }
            </table>
            <Fieldset
              className={"item-add p-mt-3"}
              legend={<span className={"item-add-legend"}><i
                className={"pi pi-plus"}></i><span>Új elem hozzáadása</span></span>}
            >
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-3 grid-col-label-input"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="name">{t('id')}</label>
                    <InputText id="name"
                               className={"p-inputtext-sm"}
                               onChange={(e) => {
                                 setNewField({
                                   ...newField,
                                   name: e.target.value
                                 })
                               }}
                               placeholder={t('id')}
                               value={newField.name}
                    />
                  </div>
                </div>
                <div className={"p-col-12 p-lg-3 grid-col-label-input"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="label">{t('label')}</label>
                    <InputText id="label"
                               className={"p-inputtext-sm"}
                               onChange={(e) => {
                                 setNewField({
                                   ...newField,
                                   label: e.target.value
                                 })
                               }}
                               placeholder={t('label')}
                               value={newField.label}
                    />
                  </div>
                </div>
                <div className={"p-col-12 p-lg-3 grid-col-label-input"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="sort">{t('sort')}</label>
                    <InputText id="sort"
                               keyfilter={"num"}
                               onChange={(e) => {
                                 setNewField({
                                   ...newField,
                                   sort: e.target.value
                                 })
                               }}
                               placeholder={t('sort')}
                               value={newField.sort}
                               className={"p-inputtext-sm"}
                    />
                  </div>
                </div>
                <div className={"p-col-12 p-lg-3 grid-col-label-input"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="related_to">{t('related_to')}</label>
                    <Dropdown  options={relations}
                              filter
                              placeholder={t('related_to')}
                              optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                              optionValue="value"
                              id={"related_to"}
                              emptyMessage={t('empty_message')}
                              onChange={(e) => {
                                setNewField({
                                  ...newField,
                                  related_to: e.value
                                })
                              }}
                              value={newField.related_to}
                              className={"p-p-0"}
                              showClear
                    />
                  </div>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-text-right"}>
                  <Button icon="pi pi-plus" className="p-button-sm p-button-success p-p-1"
                          label={t('save_new_item_label')}
                          tooltip={t('add')}
                          disabled={!newField.name || !newField.label || !newField.sort || !newField.related_to}
                          tooltipOptions={{position: 'left'}}
                          onClick={() => {
                            const nextAdditionalFields = sanitizeAdditionalFields([
                              ...formData.girp_additional_fields,
                              newField
                            ]);
                            axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
                              + "guest-information-request-page/" + formData.id,
                              {
                                girp_additional_fields: nextAdditionalFields,
                              }, {
                                params: {},
                                headers: {
                                  'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                  "Sys-name": Cookies.get("instanceId"),
                                  "Preferred-locale": Cookies.get("language")
                                }
                              })
                              .then(response => {
                                setFormData(response.data.data);
                                setNewField({
                                  name: '',
                                  label: '',
                                  sort: '',
                                  related_to: null
                                })
                                setLoading(false)
                                window.App.toastShow('success', t('success'), response.data.message)
                              })
                              .catch(error => {
                                setLoading(false)
                                window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                              })
                          }}
                  />
                </div>
              </div>
            </Fieldset>
          </Panel>
        </BlockUI>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_GuestinforequestFormComponent);
